import React from 'react'
import Header from '@/custom/components/molecules/Header'
import Footer from '@/custom/components/molecules/Footer'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import './layout.css'

const Layout = ({ children }) => {
    const matches = useMediaQuery('(min-width:1025px)')
    return (
        <>
            <Header />
            <main>{children}</main>
            <Footer />
            {/* {matches ? <Footer /> : <></>} */}
        </>
    )
}

export default Layout
